import IMask from 'imask';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import JustValidate from 'just-validate';

function autoResize(textarea) {
  textarea.style.height = 'auto';
  textarea.style.height = (textarea.scrollHeight) + 'px';
}

document.querySelectorAll('textarea').forEach(textarea => {
  textarea.addEventListener('input', function() {
    autoResize(this);
  });
  
  // Инициализация при загрузке
  autoResize(textarea);
});

// custom-select.js
class CustomSelectStyler {
    constructor(selectElement, options = {}) {
        this.select = selectElement;
        this.options = {
            className: 'custom-select',
            arrowChar: '▼',
            animationDuration: 300,
            ...options
        };
        
        this.init();
    }

    init() {
        // Создаем обертку
        const wrapper = document.createElement('div');
        wrapper.className = this.options.className;
        
        // Клонируем select и скрываем его
        const originalSelect = this.select.cloneNode(true);
        originalSelect.style.display = 'none';
        
        // Создаем кастомный элемент
        const customSelect = this.createCustomElement();
        
        // Заменяем
        this.select.parentNode.replaceChild(wrapper, this.select);
        wrapper.appendChild(originalSelect);
        wrapper.appendChild(customSelect);
        
        // Сохраняем ссылки
        this.wrapper = wrapper;
        this.originalSelect = originalSelect;
        this.customSelect = customSelect;
        
        // Инициализируем обработчики
        this.attachEvents();
    }

    createCustomElement() {
        const container = document.createElement('div');
        container.className = 'custom-select-container';
        
        // Выбранное значение
        const selected = document.createElement('div');
        selected.className = 'select-selected';
        selected.textContent = this.getSelectedText() || 'Выберите вариант';
        
        // Список опций
        const items = document.createElement('div');
        items.className = 'select-items';
        
        // Добавляем опции
        Array.from(this.select.options).forEach((option, index) => {
            const item = document.createElement('div');
            item.className = 'select-item';
            if (option.selected) item.classList.add('selected');
            item.textContent = option.text;
            item.dataset.value = option.value;
            item.dataset.index = index;
            items.appendChild(item);
        });
        
        container.appendChild(selected);
        container.appendChild(items);
        
        return container;
    }

    getSelectedText() {
        const selectedOption = this.select.options[this.select.selectedIndex];
        return selectedOption ? selectedOption.text : null;
    }

    attachEvents() {
        const selected = this.customSelect.querySelector('.select-selected');
        const items = this.customSelect.querySelectorAll('.select-item');
        const itemsContainer = this.customSelect.querySelector('.select-items');
        
        selected.addEventListener('click', () => {
            itemsContainer.classList.toggle('show');
            selected.classList.toggle('active');
        });
        
        items.forEach(item => {
            item.addEventListener('click', () => {
                const index = parseInt(item.dataset.index);
                this.originalSelect.selectedIndex = index;
                
                // Обновляем отображение
                selected.textContent = item.textContent;
                
                // Обновляем классы
                items.forEach(i => i.classList.remove('selected'));
                item.classList.add('selected');
                
                // Закрываем
                itemsContainer.classList.remove('show');
                selected.classList.remove('active');
                
                // Триггерим событие change
                const event = new Event('change', { bubbles: true });
                this.originalSelect.dispatchEvent(event);
            });
        });
        
        // Закрытие при клике вне
        document.addEventListener('click', (e) => {
            if (!this.wrapper.contains(e.target)) {
                itemsContainer.classList.remove('show');
                selected.classList.remove('active');
            }
        });
    }
}


const selects = document.querySelectorAll('select.custom');
selects.forEach(select => {
    new CustomSelectStyler(select);
});

document
	.querySelectorAll('.form__swiper')
	.forEach(function (item) {
		const form = item.querySelector('.form__form');
		const submitBtn = form.querySelector('button[type="submit"]');
		const validator = new JustValidate(form);
		form.querySelectorAll('input[type="text"][data-required]').forEach((inpt)=>{
			validator
				.addField(inpt, [
					{
					rule: 'required',
					}
				])
		})
		form.querySelectorAll('input[type="mail"][data-required]').forEach((inpt)=>{
			validator
				.addField(inpt, [
					{
					rule: 'required',
					},
					{
						rule: 'email',
					},
				])
		})
		form.querySelectorAll('input[type="checkbox"][data-required]').forEach((inpt)=>{
			validator
				.addField(inpt, [
					{
					rule: 'required',
					},
					{
						rule: 'email',
					},
				])
		})
		validator.onSuccess(( event ) => {
			event.preventDefault();
			const formData = new FormData(form);

			fetch(form.action, {
				method: form.method,
				body: formData,
				headers: {
					'Accept': 'application/json'
				}
			})
				.then(response => {
					if (!response.ok) throw new Error('Network response was not ok');
					return response.json();
				})
				.then(data => {
					slider.slideTo(1)
					form.reset();
				})
				.catch(error => {
					console.error('Error:', error);
					slider.slideTo(2);
					form.reset();
					
				})
				.finally(() => {
					submitBtn.disabled = false;
				});
		});
		console.log(validator)
		console.log(form)
		const slider = new Swiper((item), {
			slidesPerView: 1,
			spaceBetween: 12,
			preventClicks:false,
			allowTouchMove:false
		});

		item.querySelectorAll('.form__reset').forEach((btn)=>{
			btn.addEventListener('click',()=>{
				slider.slideTo(0);
			})
		});
})
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('._mask-date').forEach((item) => {
	
		const maskOptions = {
			mask: '00.00.0000'
		};
		const mask = IMask(item, maskOptions);
		item.addEventListener('blur', () => {
			console.log(item.value.length)
			if (item.value.length!=10) {
				item.value = '';
			}
			});
	})
	document.querySelectorAll('._mask-phone').forEach((item) => {
	
		const maskOptions = {
			mask: '+{7}-000-000-00-00'
		};
		const mask = IMask(item, maskOptions);
		item.addEventListener('blur', () => {
			console.log(item.value.length)
			if (item.value.length!=16) {
				item.value = '';
			}
			});
	})

});